import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/service/user.service';
import { environment } from 'environment/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  readonly currentYear = new Date().getFullYear();
  selectedLanguage:any = "en";
  forgetPasswordForm!: FormGroup;
  submitted!: boolean;
  errormsg: any;
  supportedLanguages: { code: string, name: string }[] = [
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' }
  ];
  constructor(private http: HttpClient, public _router: Router,
    private userService: UserService,
    private _translate: TranslateService,
    private toastr: ToastrService, private translate: TranslateService, private formBuilder: FormBuilder,) {
      translate.setDefaultLang('en');
      const savedLanguage = localStorage.getItem('selectedLanguage');
      if (savedLanguage) {
        this.selectedLanguage = savedLanguage;
        translate.use(savedLanguage);
      } else {
        translate.use('en');
      }
  }

 
  ngOnInit() {
    this.forgetPasswordForm = this.formBuilder.group({
      email: [
        null,
        [
          Validators.required,
          this.noWhitespaceValidator,
          Validators.pattern('^[aA-zZ0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
    });
    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      this.selectedLanguage = storedLanguage;
    } else {
      this.selectedLanguage = 'en';
      localStorage.setItem('selectedLanguage', 'en');
    }
    this.translate.use(this.selectedLanguage);
  }

  changeLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.userService.loadLang.next(lang);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.forgetPasswordForm.controls
  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  blurmsg() {
    this.errormsg = '';
  }

  sendEmailResetPassword() {
   const url: any = environment.ui + '/reset-password/change';
    this.submitted = true;
    let data: any = {
      email: this.forgetPasswordForm.controls['email'].value,
      uri: url,
    };
    this.userService.sendEmailResetPassword(data).subscribe(
      (response) => {
        this._router.navigate(['/login']);
        this.toastr.success('Reset-Password successfully');
      },
      (err) => {
         this.errormsg =
          'forgotpassword.emailNotExists';
          this.toastr.error('Invalid Email!');
      }
    );
  }
}
